export default __webpack_public_path__ + "static/media/page-icon.529462b8.svg";